// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { appReducer } from 'store/behaviors/loader';
import { deleteTaskBranch, sortTasksByParentPosition } from 'store/app/tplmgmt/task';
import capabilities from './capabilities';
import initialState from './grid';

const slice = createSlice({
    name: 'tplWorkOrder',
    initialState,
    reducers: {
        ...appReducer(capabilities),
        insertTasks(state, action) {
            if (!Array.isArray(state?.list)) return;

            const { updItemId, tasks } = action?.payload || {};
            const item = state.list.find((item) => item.id === updItemId);

            if (!item) return;

            item.tasks = sortTasksByParentPosition([...(Array.isArray(item.tasks) ? item.tasks : []), ...[].concat(tasks || [])]);
        },
        updateTasks(state, action) {
            if (!Array.isArray(state?.list)) return;

            const { updItemId, tasks } = action?.payload || {};
            const item = state.list.find((item) => item.id === updItemId);

            if (!item) return;

            if (!Array.isArray(item.tasks)) {
                item.tasks = [];
            }

            [].concat(tasks || []).forEach((updTask) => {
                if (!updTask?.id) return;

                const taskIndex = item.tasks.findIndex((task) => task.id === updTask.id);

                if (taskIndex === -1) {
                    item.tasks.push(updTask);
                } else {
                    item.tasks[taskIndex] = {
                        ...item.tasks[taskIndex],
                        ...updTask
                    };
                }
            });

            item.tasks = sortTasksByParentPosition(item.tasks);
        },
        deleteTasks(state, action) {
            if (!Array.isArray(state?.list)) return;

            const { updItemId, tasks } = action?.payload || {};
            const item = state.list.find((item) => item.id === updItemId);

            if (!item || !Array.isArray(item.tasks)) return;

            item.tasks = []
                .concat(tasks || [])
                .filter(Boolean)
                .reduce((nextTasks, targetTask) => deleteTaskBranch(nextTasks, targetTask), item.tasks);
        }
    }
});

export default slice.reducer;

export const tplWorkOrderActions = slice.actions;
